import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import classnames from 'classnames';
import * as styles from './outputModal.module.scss';

type ModalType = {
  isOpen: boolean;
  setter: React.Dispatch<React.SetStateAction<boolean>>;
  routeRef: React.RefObject<HTMLDivElement>;
  isStatic?: boolean;
};

const OutputModal: React.FC<ModalType> = ({ isOpen, setter, routeRef, isStatic = false, children }) => {
  const [close, setClose] = useState(false);
  const [vh, setVh] = useState(0);
  const [scrollPos, setScrollPos] = useState(0);
  const style = classnames(styles.modal, { [styles.active]: isOpen, [styles.close]: close });
  const popupParentRef = useRef<HTMLDivElement | null>(null);
  const handleClose = (): void => {
    setClose(true);
    setTimeout(() => {
      setClose(false);
      setter(false);
    }, 1024);
  };

  useEffect(() => {
    setVh(window.innerHeight);
    if (routeRef.current) {
      if (isOpen) {
        setScrollPos(window.scrollY);
        const windowScrollPos = window.scrollY;
        document.body.classList.add('modalOpen');
        document.body.style.maxHeight = vh < 1 ? '100vh' : `${vh}px`;
        document.body.scrollTop = windowScrollPos;
      } else {
        document.body.classList.remove('modalOpen');
        document.body.style.maxHeight = '';
        window.scroll({ top: scrollPos });
      }
    }
  }, [isOpen]);

  const portal = (target: HTMLDivElement) => {
    return createPortal(
      <div
        className={style}
        ref={popupParentRef}
        onClick={(e): void => {
          popupParentRef.current === e.target && handleClose();
        }}
      >
        <div className={styles.inner}>
          <div className={styles.modalContent}>{children}</div>
          <i className={styles.modalClose} onClick={handleClose}>
            close
          </i>
        </div>
      </div>,
      target
    );
  };

  // return
  if (!routeRef.current) return null;
  if (isStatic) return portal(routeRef.current);
  return isOpen ? portal(routeRef.current) : null;
};

export default OutputModal;
